// axiosConfig.ts

import axios, { AxiosInstance } from 'axios'
import { base_url_be } from '../constants/global'

const axiosInstance: AxiosInstance = axios.create({
  baseURL: base_url_be, // Ganti dengan baseURL yang sesuai
  timeout: 18000, // Sesuaikan dengan timeout yang diinginkan
})

// Interceptor untuk menangani request sebelum dikirim
axiosInstance.interceptors.request.use(
  (config) => {
    // Misalkan token disimpan dalam localStorage dengan key 'authToken'
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor untuk menangani response
axiosInstance.interceptors.response.use(
  (response) => {
    // Lakukan penanganan jika diperlukan
    return response
  },
  (error) => {
    // Guard `error.response`: network errors / aborts / CORS rejections deliver
    // an Error with `response` undefined; touching `.status` would throw a
    // TypeError that masks the original failure on every downstream `.catch`.
    //
    // 401 messaging is *only* sensible when a logged-in session is actually
    // expiring. For anonymous flows (login/register/invitation accept/forgot-
    // password) a 401 means "the call shouldn't have been authed" or "browser
    // cached a stale 308 to an authed endpoint" — alerting "U bent afgemeld"
    // there is confusingly wrong (the user was never logged in). Gate the
    // redirect on token presence so anonymous flows just propagate the error
    // to the page's own `.catch` (which now shows a contextual snackbar).
    if (error?.response?.status === 401) {
      const hadSession = typeof window !== 'undefined' && !!localStorage.getItem('accessToken')
      if (hadSession) {
        alert('U bent afgemeld omdat uw sessie verlopen is')
        // Bersihkan data pengguna dari localStorage
        localStorage.removeItem('user')
        localStorage.removeItem('UID')
        localStorage.removeItem('accessToken')

        // Arahkan ke halaman login atau halaman lainnya
        window.location.href = '/'
      }
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
